import { QueryClientProvider } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { FC, PropsWithChildren } from 'react';

import { useInitRef } from '../../../hooks/use-init-ref';
import { useEnvironment } from '../../application';
import { createPersister, shouldPersist } from '../lib/persister';
import { useQueryClientStore } from '../lib/store';

export const QueryProvider: FC<PropsWithChildren> = (props) => {
	const client = useQueryClientStore((state) => state.queryClient);
	const persister = useInitRef(() => createPersister());

	if (useEnvironment() === 'test') {
		return <QueryClientProvider client={client} {...props} />;
	}

	return (
		<PersistQueryClientProvider
			client={client}
			persistOptions={{
				dehydrateOptions: {
					shouldDehydrateQuery: shouldPersist,
				},
				maxAge: 24 * 60 * 60 * 1000,
				persister,
			}}
			{...props}
		/>
	);
};
